import React, { memo, useCallback, useEffect, useMemo } from "react";
import { useForm, Controller } from "react-hook-form";
import { Error, CustomSelect, Label, Button } from "../";
import { useFilteredData } from "../../Hooks";

const EVENT_OPTIONS = [
  { label: "BetFair", value: "1" },
  { label: "Radhe", value: "2" },
];

const GAME_FILTER_OPTIONS = [
  { label: "All", value: "All" },
  { label: "Today", value: "Today" },
  { label: "Future", value: "Future" },
];

const Filter = ({
  isSport = false,
  isTournament = false,
  isMatch = false,
  allMatch = false,
  isEvent = false,
  isGame = false,
  isEventDisabled = false,
  isBettingType = false,
  isRole = false,
  isUser = false,
  sportLabel = "Sports",
  tournamentLabel = "Tournament",
  matchLabel = "Matches",
  roleLabel = "Role",
  userLabel = "User",
  handleFilterParams = () => {},
  apiParam,
  defaultParams = {},
  isType = false,
  marketTypeData = [],
  buttonVisible = true,
  selectedSource,
  autoSelectFirstSport = false,
}) => {
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      sports: null,
      tournament: null,
      match: null,
      marketType: null,
      role: null,
      user: null,
      event:
        EVENT_OPTIONS.find((item) => item.value === String(selectedSource)) ||
        EVENT_OPTIONS[0],
      game:
        GAME_FILTER_OPTIONS.find(
          (item) => item.value === String(selectedSource),
        ) || GAME_FILTER_OPTIONS[0],
    },
  });

  // Watch values for dependencies
  const sportsValue = watch("sports");
  const tournamentValue = watch("tournament");
  const matchValue = watch("match");
  const roleValue = watch("role");
  const userValue = watch("user");

  const {
    sportOptions,
    roleOptions,
    userOptions,
    tournamentOptions,
    matchAllOptions,
    matchOptions,
  } = useFilteredData({
    sport: sportsValue?.value,
    tournament: tournamentValue?.value,
    dependantMatch: isMatch,
    match: matchValue?.value,
    role: roleValue?.value,
    allMatch,
    enableTournament: isTournament,
    enableSport: isSport,
    enableRole: isRole,
    enableUser: isUser,
    apiParam,
  });

  const selectedMatchOptions = allMatch ? matchAllOptions : matchOptions;

  const sportMap = useMemo(
    () => new Map(sportOptions.map((item) => [String(item.value), item])),
    [sportOptions],
  );

  const roleMap = useMemo(
    () => new Map(roleOptions.map((item) => [String(item.value), item])),
    [roleOptions],
  );

  // const userMap = useMemo(
  //   () => new Map(userOptions.map((item) => [String(item.value), item])),
  //   [userOptions],
  // );

 console.log("userOptions", userOptions);

  const tournamentMap = useMemo(
    () => new Map(tournamentOptions.map((item) => [String(item.value), item])),
    [tournamentOptions],
  );

  const matchMap = useMemo(
    () =>
      new Map(selectedMatchOptions.map((item) => [String(item.value), item])),
    [selectedMatchOptions],
  );

  const marketTypeOptions = useMemo(
    () =>
      (Array.isArray(marketTypeData) ? marketTypeData : []).map((item) => ({
        value:
          item?.value ??
          item?.Id ??
          item?.id ??
          item?.Value ??
          item?.name ??
          item?.Name ??
          String(item),
        label:
          item?.label ??
          item?.Name ??
          item?.name ??
          String(item?.value ?? item),
      })),
    [marketTypeData],
  );

  useEffect(() => {
    if (defaultParams.roleId && roleMap.size) {
      setValue("role", roleMap.get(String(defaultParams.roleId)) || null);
    }
  }, [defaultParams.roleId, roleMap, setValue]);

  // useEffect(() => {
  //   if (defaultParams.userId && userMap.size) {
  //     setValue("user", userMap.get(String(defaultParams.userId)) || null);
  //   }
  // }, [defaultParams.userId, userMap, setValue]);

  useEffect(() => {
    if (defaultParams.sportId && sportMap.size) {
      setValue("sports", sportMap.get(String(defaultParams.sportId)) || null);
    }
  }, [defaultParams.sportId, sportMap, setValue]);

  useEffect(() => {
    if (defaultParams.tournamentId && tournamentMap.size) {
      setValue(
        "tournament",
        tournamentMap.get(String(defaultParams.tournamentId)) || null,
      );
    }
  }, [defaultParams.tournamentId, tournamentMap, setValue]);

  useEffect(() => {
    if (defaultParams.matchId && matchMap.size) {
      setValue("match", matchMap.get(String(defaultParams.matchId)) || null);
    }
  }, [defaultParams.matchId, matchMap, setValue]);
  useEffect(() => {
    if (
      autoSelectFirstSport &&
      !defaultParams.sportId &&
      sportOptions.length > 0 &&
      !sportsValue
    ) {
      const firstSport = sportOptions[0];

      setValue("sports", firstSport);

      handleFilterParams({
        sports: firstSport,
      });
    }
  }, [
    autoSelectFirstSport,
    defaultParams.sportId,
    sportOptions,
    sportsValue,
    setValue,
    handleFilterParams,
  ]);
  const handleClear = useCallback(() => {
    reset({
      sports: null,
      role: null,
      user: null,
      tournament: null,
      match: null,
      marketType: null,
      event: EVENT_OPTIONS[0],
      game: GAME_FILTER_OPTIONS[0],
    });

    handleFilterParams({
      sports: null,
      role: null,
      user: null,
      tournament: null,
      match: null,
      marketType: null,
      game: GAME_FILTER_OPTIONS[0],
    });
  }, [reset, handleFilterParams]);

  return (
    <form
      className="filter_tableBox"
      onSubmit={handleSubmit(handleFilterParams)}
    >
      <div className="row align-items-end">
        {isSport && (
          <div className="col-xl-2 col-lg-3 col-12">
            <div className="input_control">
              <Label htmlFor="sports" className="form-label">
                {sportLabel}
                {/* <span className="text-danger">*</span> */}
              </Label>
              <Controller
                name="sports"
                control={control}
                render={({ field }) => (
                  <CustomSelect
                    value={field.value}
                    onChange={(selected) => {
                      field.onChange(selected);
                      setValue("tournament", null);
                      setValue("match", null);
                    }}
                    onBlur={field.onBlur}
                    options={sportOptions}
                    placeholder="All"
                    isMulti={false}
                  />
                )}
              />
              {errors.sports && (
                <Error>{errors.sports.message || errors.sports}</Error>
              )}
            </div>
          </div>
        )}

        {isEvent && (
          <div className="col-xl-2 col-lg-3 col-12">
            <div className="input_control">
              <Label htmlFor="event" className="form-label">
                Event
                {/* <span className="text-danger">*</span> */}
              </Label>
              <Controller
                name="event"
                control={control}
                render={({ field }) => (
                  <CustomSelect
                    value={field.value}
                    onChange={field.onChange}
                    onBlur={field.onBlur}
                    options={EVENT_OPTIONS}
                    placeholder="Select Event"
                    isMulti={false}
                    isDisabled={isEventDisabled}
                  />
                )}
              />
              {errors.event && (
                <Error>{errors.event.message || errors.event}</Error>
              )}
            </div>
          </div>
        )}

        {isTournament && (
          <div className="col-xl-2 col-lg-3 col-12">
            <div className="input_control">
              <Label htmlFor="tournament" className="form-label">
                {tournamentLabel}
                {/* <span className="text-danger">*</span> */}
              </Label>
              <Controller
                name="tournament"
                control={control}
                render={({ field }) => (
                  <CustomSelect
                    value={field.value}
                    onChange={(selected) => {
                      field.onChange(selected);
                      setValue("match", null);
                    }}
                    onBlur={field.onBlur}
                    options={tournamentOptions}
                    placeholder="All"
                    isMulti={false}
                  />
                )}
              />
              {errors.tournament && (
                <Error>{errors.tournament.message || errors.tournament}</Error>
              )}
            </div>
          </div>
        )}

        {(allMatch || isMatch) && (
          <div className="col-xl-2 col-lg-3 col-12">
            <div className="input_control">
              <Label htmlFor="match" className="form-label">
                {matchLabel}
                {/* <span className="text-danger">*</span> */}
              </Label>
              <Controller
                name="match"
                control={control}
                render={({ field }) => (
                  <CustomSelect
                    value={field.value}
                    onChange={field.onChange}
                    onBlur={field.onBlur}
                    options={allMatch ? matchAllOptions : matchOptions}
                    placeholder="All"
                    isMulti={false}
                  />
                )}
              />
              {errors.match && (
                <Error>{errors.match.message || errors.match}</Error>
              )}
            </div>
          </div>
        )}

        {isType && marketTypeData && (
          <div className="col-lg-2 col-md-6 col-12">
            <div className="input_control">
              <Label htmlFor="marketType" className="form-label">
                Type
                {/* <span className="text-danger">*</span> */}
              </Label>
              <Controller
                name="marketType"
                control={control}
                render={({ field }) => (
                  <CustomSelect
                    value={field.value}
                    onChange={field.onChange}
                    onBlur={field.onBlur}
                    options={marketTypeOptions}
                    placeholder="Select marketType"
                    isMulti={false}
                  />
                )}
              />
            </div>
          </div>
        )}

        {isRole && (
          <div className="col-xl-2 col-lg-3 col-12">
            <div className="input_control">
              <Label htmlFor="role" className="form-label">
                {roleLabel}
                {/* <span className="text-danger">*</span> */}
              </Label>
              <Controller
                name="role"
                control={control}
                render={({ field }) => (
                  <CustomSelect
                    value={field.value}
                    onChange={(selected) => {
                      field.onChange(selected);
                      setValue("tournament", null);
                      setValue("match", null);
                    }}
                    onBlur={field.onBlur}
                    options={roleOptions}
                    placeholder="All Roles"
                    isMulti={false}
                  />
                )}
              />
              {errors.role && (
                <Error>{errors.role.message || errors.role}</Error>
              )}
            </div>
          </div>
        )}

        {isUser && (
          <div className="col-xl-2 col-lg-3 col-12">
            <div className="input_control">
              <Label htmlFor="user" className="form-label">
                {userLabel}
                {/* <span className="text-danger">*</span> */}
              </Label>
              <Controller
                name="user"
                control={control}
                render={({ field }) => (
                  <CustomSelect
                    value={field.value}
                    onChange={(selected) => {
                      field.onChange(selected);
                      setValue("tournament", null);
                      setValue("match", null);
                    }}
                    onBlur={field.onBlur}
                    options={userOptions}
                    placeholder="Select User"
                    isMulti={false}
                  />
                )}
              />
              {errors.user && (
                <Error>{errors.user.message || errors.user}</Error>
              )}
            </div>
          </div>
        )}

        {isGame && (
          <div className="col-xl-2 col-lg-3 col-12">
            <div className="input_control">
              <Label htmlFor="event" className="form-label">
                Game Filter
                {/* <span className="text-danger">*</span> */}
              </Label>
              <Controller
                name="game"
                control={control}
                render={({ field }) => (
                  <CustomSelect
                    value={field.value}
                    onChange={field.onChange}
                    onBlur={field.onBlur}
                    options={GAME_FILTER_OPTIONS}
                    placeholder="Select Filter"
                    isMulti={false}
                    isDisabled={isEventDisabled}
                  />
                )}
              />
              {errors.game && (
                <Error>{errors.game.message || errors.game}</Error>
              )}
            </div>
          </div>
        )}

        {buttonVisible && (
          <div className="col-xl-2 col-lg-3 col-12">
            <div className="btn_box">
              <Button type="submit" className="btn_submit">
                Search
              </Button>
              <Button type="button" className="btn_clear" onClick={handleClear}>
                Clear
              </Button>
            </div>
          </div>
        )}
      </div>
    </form>
  );
};

export default memo(Filter);
